import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroBackground from '../images/landing-background.jpg';
import HeroText from '../images/missouri hacks.svg';
import Button from '../components/Button';
import ScubaTruman1 from '../images/scuba-tiger.png';
import ScubaTruman2 from '../images/scuba-tiger2.png';
import Location from '../images/location.png';
import DayOfCoding from '../images/day-of-coding.svg';
import Pillars from '../images/pillars.png';
import Hackathon from '../images/hackathon.svg'
import Calendar from '../images/calendar.png';
import Sponsors from '../images/sponsorships.svg';
import ShelterInsurance from '../images/shelter-insurance.jpg';
import EquipmentShare from '../images/equipment-share.jpg';
import LeonardoDRS from '../images/leonardo-drs.jpg';
import Staff from '../components/Staff';
import Derek from '../images/staff/derek.jpg';
import Gage from '../images/staff/gage.jpg';
import Martin from '../images/staff/martin.jpg';
import Mel from '../images/staff/mel.jpeg';
import Ashton from '../images/staff/ashton.jpeg';
import Leadership from '../images/leadership.svg';
import FAQ from '../images/faq.svg';
import Faq from '../components/FAQ';

/* Gallery */
import Gallery1 from '../images/gallery/1.jpg';
import Gallery2 from '../images/gallery/2.jpg';
import Gallery3 from '../images/gallery/3.jpg';
import Gallery4 from '../images/gallery/4.jpg';
import Gallery5 from '../images/gallery/5.jpg';
import Gallery6 from '../images/gallery/6.jpg';
import Gallery7 from '../images/gallery/7.jpg';
import Gallery8 from '../images/gallery/8.jpeg';
import Gallery9 from '../images/gallery/9.jpeg';
import Gallery10 from '../images/gallery/10.jpeg';
import Gallery11 from '../images/gallery/11.jpeg';

export default function Home() {

    function moveToDayOfCoding() {
        document.getElementById('day-of-coding').scrollIntoView({ behavior: 'smooth' });
    }

    function moveToHackathon() {
        document.getElementById('hackathon').scrollIntoView({ behavior: 'smooth' });
    }

    function registerButton() {
        window.open("https://missouri.qualtrics.com/jfe/form/SV_aW7iuYIZpNXiphQ", "_blank");
    }

    return (
        <div id = "home-page" style = {{}}>
            {/* Navbar Section */}
            <Navbar/>

            {/* Hero Section */}
            <div id = "home-hero" style = {{backgroundImage: `url(${HeroBackground})`, backgroundSize: 'cover', paddingBottom: '50px', overflowX: 'hidden', minHeight: '80vh', justifyContent: 'center', flexDirection: 'column', display: 'flex'}}>
                <div id = "hero-content" style = {{display: 'flex', marginLeft: '10px',  marginRight: '10px', flexWrap: 'wrap', justifyContent: 'center', gap: '30px'}}>
                    <div id = "hero-left">
                        <img src = {HeroText} alt = "Missouri Hacks" style = {{width: '600px', maxWidth: '90vw'}}/>
                        <p style = {{fontSize: '24px'}}>EVENTS</p>
                        <div id = "hero-buttons-wrapper" style = {{display: 'flex', gap: '10px'}}>
                            <Button onClick = {moveToDayOfCoding} text = "DAY OF CODING"></Button>
                            <Button onClick = {moveToHackathon} text = "HACKATHON"></Button>
                        </div>
                        <p style = {{fontSize: '24px'}}>WHEN & WHERE</p>
                         <div id = "location-wrapper" style = {{display: 'flex', marginTop: '5px'}}>
                            <img src = {Calendar} style = {{width: '15px', height: '16px', marginTop: '2px'}}></img>
                            <p style = {{marginBottom: 'auto', marginTop: 'auto', marginLeft: '10px', color: 'var(--light-blue)'}}>November 15th, 2025</p>
                        </div>
                        <div id = "location-wrapper" style = {{display: 'flex', marginTop: '5px'}}>
                            <img src = {Location} style = {{width: '15px', height: '20px'}}></img>
                            <p style = {{marginBottom: 'auto', marginTop: 'auto', marginLeft: '10px', color: 'var(--light-blue)'}}>Lafferre Hall, University of Missouri - Columbia</p>
                        </div>
                    </div>
                    <div id = "hero-right">
                        <img id = "scuba-truman-1" src = {ScubaTruman1} alt = "Scuba Truman" style = {{maxWidth: '300px', marginTop: '0px', paddingLeft: '30px'}}/>
                    </div>
                </div>
            </div>

            {/* Image Carousel Section */}
            <div id = "image-carousel">
                <div id = "image-carousel-wrapper" style = {{display: 'flex', gap: '20px', overflowX: 'auto', paddingTop: '20px', paddingBottom: '20px', marginLeft: '10px', marginRight: '10px', overflowX: 'hidden'}}>
                    <img className = "carousel-image" src = {Gallery2} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery3} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery4} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery5} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery6} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery7} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery8} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery9} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery10} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                    <img className = "carousel-image" src = {Gallery11} alt = "Gallery 1" style = {{height: '200px', borderRadius: '10px'}}></img>
                </div>
            </div>

            {/* Day of Coding Section */}
            <div id = "day-of-coding" style = {{paddingTop: '60px', paddingBottom: '60px', overflowX: 'hidden'}}>
                <div id = "doc-pillars-wrapper" style = {{backgroundImage:`url(${Pillars})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', marginTop: '50px', minHeight: '500px'}}>
                    <div id = "doc-hero" style = {{display: 'flex', flexWrap: 'wrap', gap: '60px', justifyContent: 'center', width: '100%', minHeight: '500px'}}>{/* Day of Coding Hero Section */}
                        <div id = "doc-hero-left" style = {{height: '100%', marginTop: 'auto', marginBottom: 'auto'}}>
                            <img src = {Gallery1} style = {{width: '400px', marginTop: 'auto', marginBottom: 'auto'}}></img>
                        </div>
                        <div id = "doc-hero-right" style = {{marginTop: 'auto', marginBottom: 'auto'}}>
                            <img src = {DayOfCoding} style = {{height: '70px', marginTop: '20px', maxWidth: '90vw'}}></img>
                            <p style = {{maxWidth: '500px', fontSize: '24px'}}>Learn the fundamentals of programming through interactive coding tutorials and thinking exercises. No experience is needed to attend!</p>
                            <Button text = "REGISTER" onClick={registerButton}></Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hackathon Section */}
            <div id = "hackathon" style = {{paddingTop: '60px', paddingBottom: '100px', overflowX: 'hidden'}}>
                <div id = "hackathon-hero" style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '30px'}}>
                    <div id = "hackathon-hero-left">
                        <img src = {Hackathon} style = {{height: '70px', marginTop: '20px', maxWidth: '90vw'}}></img>
                        <p style = {{maxWidth: '500px', fontSize: '24px'}}>Show off your talent in a full day open-ended hackathon for awesome prizes. The theme this year is oceanic. Remember, no coding early!</p>
                        <Button text = "REGISTER" onClick={registerButton}></Button>
                    </div>
                    <div id = "hackathon-hero-right">
                        <img id = "scuba-truman-2" src = {ScubaTruman2} style = {{maxWidth: '400px', marginTop: 'auto', marginBottom: 'auto'}}></img>
                    </div>
                </div>
            </div>

            {/* Sponsors Section */}
            <div id = "sponsors" style = {{textAlign: 'center', backgroundColor: 'var(--medium-blue)', paddingBottom: '60px'}}>
                <img src = {Sponsors} style = {{height: '70px', maxWidth: '90vw', marginTop: '100px'}}></img>
                <p style = {{fontSize: '24px'}}>Without our sponsors, this event would not be possible!</p>
                <div id = "sponsors-logos-wrapper" style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '30px', marginTop: '30px', marginBottom: '50px'}}>
                    <a href = "https://www.shelterinsurance.com/"><img src = {ShelterInsurance} style = {{height: '200px'}}></img></a>
                    <a href = "https://www.equipmentshare.com/"><img src = {EquipmentShare} style = {{height: '200px'}}></img></a>
                    <a href = "https://www.leonardodrs.com/"><img src = {LeonardoDRS} style = {{height: '200px'}}></img></a>
                </div>
            </div>

            {/* Leadership Section */}
            <div id = "leadership" style = {{textAlign: 'center', paddingBottom: '100px'}}>
                <img src = {Leadership} style = {{height: '70px', maxWidth: '90vw', marginTop: '100px'}}></img>
                <div id = "staff-wrapper" style = {{display: 'flex', flexWrap: 'wrap', marginTop: '60px', justifyContent: 'center'}}>
                    <Staff image = {Derek} role = "Director" linkedin = "https://www.linkedin.com/in/derek-nissen/" name = "Derek Nissen"/>
                    <Staff image = {Gage} role = "Marketing Coordinator" linkedin = "https://www.linkedin.com/in/thegagesmith/" name = "Gage Smith"/>
                    <Staff image = {Martin} role = "Hacking Coordinator" linkedin = "https://www.linkedin.com/in/mart%C3%ADnleija/" name = "Martín Leija"/>
                    <Staff image = {Mel} role = "Event Experience Coordinator" linkedin = "https://www.linkedin.com/in/amelisa-nezirovic-6bba422b5/" name = "Mel Nezirovich"/>
                    <Staff image = {Ashton} role = "Logistics Coordinator" linkedin = "https://www.linkedin.com/in/ashtonwooster/" name = "Ashton Wooster"/>
                </div>
            </div>

            {/* FAQ Section */}
            <div id = "faq" style = {{textAlign: 'center', paddingBottom: '100px'}}>
                <img src = {FAQ}></img>
                <div id = "faqs-wrapper" style = {{width: '800px', maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: '60px', display: 'flex', flexDirection: 'column', gap: '14px'}}>
                    <Faq question = "What is Missouri Hacks?" answer = "Missouri Hacks is an annual coding event hosted at the University of Missouri with the intention of promoting STEM education at the high school level. Originating in 2023, the event has steadily increased in size each year. The event was spearheaded by the SOARE club at Mizzou and has combined efforts with the Mizzou Computing Association starting in 2025."></Faq>
                    <Faq question = "What will I learn at Day of Coding?" answer = "The Day of Coding experience is a way for beginner programmers to dive into the fundamentals of programming. In this experience, participants will learn about basic syntax, control flow, and dependency management. The material will be taught in Python."></Faq>
                    <Faq question = "What is a hackathon?" answer = "A hackathon is an event where competitors are given a time constraint to build a project that solves a certain problem relating to a theme. At the end of the event, projects are judged, and winners win prizes."></Faq>
                    <Faq question = "How many people can be in a team?" answer = "In the hackathon, competitors can work in groups of 1-4."></Faq>
                    <Faq question = "Can I participate in both the Day of Coding and the hackathon?" answer = "Unfortunately, attendees can only take part in one of the experiences as they are ran concurrently."></Faq>
                    <Faq question = "Are AI tools allowed in the hackathon?" answer = "Competitors are allowed to use any FREE AI tools to assist them in building projects. However, their submission must clearly state where they used AI."></Faq>
                    <Faq question = "Can guardians watch?" answer = "Guardians can attend the opening and closing ceremonies for the hackathon, but won't be allowed into the hacking room to ensure a fair competition. Guardians CAN however attend any of the Day of Coding tutorials/workshops. We also have optional events planned for guardians during the day. Guardians can also bring their student(s) somewhere for lunch *must sign out and back in*."></Faq>
                </div>
            </div>

            {/* Footer Section */}
            <Footer/>
        </div>
    )
}